import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Contact from './pages/Contact';
import ToolDetails from './pages/ToolDetails';
import Login from './pages/Login';
import About from './pages/About';
import AdminDashboard from './pages/admin/AdminDashboard.jsx';
import AdminSubscribers from './pages/admin/AdminSubscribers.jsx';
import AdminUsers from './pages/admin/AdminUsers';
import AdminMessages from './pages/admin/AdminMessages.jsx';
import { PaginationProvider } from './context/PaginationContext';

const AppContent = () => {
  const location = useLocation();
  const [user, setUser] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const name = localStorage.getItem('name');
    if (token && name) {
      setUser({ name });
    }

    // Update state if user logs in later
    const handleUserLogin = () => {
      const name = localStorage.getItem('name');
      const token = localStorage.getItem('token');
      if (token && name) setUser({ name });
    };

    window.addEventListener('user-logged-in', handleUserLogin);
    return () => {
      window.removeEventListener('user-logged-in', handleUserLogin);
    };
  }, []);

  const handleLogin = (loggedInUser) => {
    setUser(loggedInUser); // still safe to use if you manually pass
  };

  const hideFooter = location.pathname === '/login' || location.pathname === '/contact' || location.pathname === '/about';

  return (
    <PaginationProvider>
      <div className="app-container">
        <Navbar user={user} setUser={setUser} />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/tool/:id" element={<ToolDetails />} />
            <Route path="/login" element={<Login onLogin={handleLogin} />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/about" element={<About />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/admin/subscribers" element={<AdminSubscribers />} />
            <Route path="/admin/users" element={<AdminUsers />} />
            <Route path="/admin/messages" element={<AdminMessages />} />
          </Routes>
        </main>
        {!hideFooter && <Footer />}
      </div>
    </PaginationProvider>
  );
};

const App = () => (
  <Router>
    <AppContent />
  </Router>
);

export default App;
